// Neu (SPEC 03 §9 „Common states“) — die drei Zustände jedes Datenblocks, einheitlich:
//   Leer    → EmptyState mit der Lineatur als Illustration (Schulheft-Linien, reine Zier)
//   Fehler  → „Das lädt gerade nicht.“ + „Erneut versuchen“; nie Statuscodes oder Servernamen
//   Laden   → Halo erst nach 2 s (useVerzoegert), sonst Ruhe
import type { ReactNode } from "react";
import { Btn, EmptyState } from "../ui";
import { Denkloader, LOADER_MS } from "../ladewerk";
import { useVerzoegert } from "../../hooks/useVerzoegert";
import { TX } from "../../lib/texte";

/** Die Lineatur als Leer-Illustration (180 × 24, `klein` 90 × 14). Nur Zier, nie Daten. */
export function LeerLineatur({ klein = false }: { klein?: boolean }) {
  return <div className={`leer-lineatur${klein ? " klein" : ""}`} aria-hidden="true" />;
}

export function Leer({ titel, sub, aktion }: { titel: string; sub?: string; aktion?: ReactNode }) {
  return <EmptyState bild={<LeerLineatur />} title={titel} sub={sub} aktion={aktion} />;
}

export function LadeFehler({ erneut, text = TX.allgemein.laedtNicht }: { erneut?: () => void; text?: string }) {
  return (
    <div className="lade-fehler" role="alert">
      <span>{text}</span>
      {erneut && (
        <Btn type="button" size="sm" variant="ghost" icon="arrows-clockwise" onClick={erneut}>
          {TX.allgemein.erneut}
        </Btn>
      )}
    </div>
  );
}

/** Halo, aber erst wenn es länger als 2 s dauert (SPEC 03 §8.2 Punkt 3). */
export function SpaeterHalo({ laedt, label, hoehe = 120 }: { laedt: boolean; label?: string; hoehe?: number }) {
  const zeigen = useVerzoegert(laedt, LOADER_MS);
  if (!laedt) return null;
  return (
    <div className="lade-mitte" style={{ minHeight: hoehe }} aria-busy="true">
      {zeigen && <Denkloader variante="halo" groesse={16} label={label} />}
    </div>
  );
}
